module.exports = require('./helpers/bundle-url').getBundleURL('bLVlz') + "logo.c51670a8.svg";